export default "__VITE_ASSET__ktCvDyBw__"